import React, { useEffect, useState } from 'react';

import Spinner from '../../utils/Spinner';
import RequestForm from './RequestForm';
import {useSearchParams, useParams} from 'react-router-dom';
import axios from 'axios';
import InvalidTokenDialog from './InvalidTokenDialog';
import { toast, ToastContainer } from 'react-toastify';
import InfoConfirmation from './InfoConfirmation';
const SubscriptionRequest = () => {
  const [tokenInfo, setTokenInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();
  const token = params.token;

  useEffect(() => {
    getTokenInfo(token);
  }, [token]);

  function getTokenInfo() {
    setIsLoading(true);
    axios.post(`/subscription/v1/create-instance/${token}`).then((response) => {
      setTokenInfo(response.data);
      
    })
    .catch((error) => {
      toast('ERROR GETTING THE TOKEN INFO', {
        autoClose: 6000,
        type: toast.TYPE.ERROR,
      });
    })
    .finally(() => {
      setIsLoading(false);
    });

  }


  return (
    <>
      <ToastContainer />
      <div >
        {isLoading ?
        <div className="py-4 grid grid-cols-3">
          <div>
            <Spinner />
          </div>
        </div> 
        :
        <div>
          {tokenInfo.tokenUsed && <InvalidTokenDialog />}
          {!tokenInfo.tokenUsed && <InfoConfirmation tokenInfo={tokenInfo}/>}
            
          </div>
        }
      </div>
    </>
  );
};

export default SubscriptionRequest;